import React, { Component } from "react";
import injectSheet from "react-jss";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { StripeProvider, Elements } from "react-stripe-elements";
import { connect } from "react-redux";
import { formStyle } from "../../Theme/Theme";
import UserInfoForm from "./SignupComponents/UserInfoForm";
import ChoosePlanForm from "./SignupComponents/ChoosePlanForm";
import CardInfoForm from "./SignupComponents/CardInfoForm";
import * as Actions from "../../Actions/Actions";
import TagManager from 'react-gtm-module'

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: null,
      lastName: null,
      email: null,
      password: null,
      plan: null,
      userInfoSaved: false
    };
  }

  render() {
    return (
      <Switch>
        <Route
          path="/welcome/signup/userInfo"
          render={props => (
            <UserInfoForm {...props} onSubmit={this.saveUserInfo} />
          )}
        />
        {this.state.userInfoSaved ? (
          <Route
            path="/welcome/signup/choosePlan"
            render={props => (
              <ChoosePlanForm {...props} onSubmit={this.saveChosenPlan} />
            )}
          />
        ) : null}
        {this.state.userInfoSaved ? (
          <Route
            path="/welcome/signup/paymentMethod"
            render={this.renderCardForm}
          />
        ) : null}
        <Redirect to="/welcome/signup/userInfo" />
      </Switch>
    );
  }

  renderCardForm = props => {
    return (
      <StripeProvider apiKey="pk_live_aSbECe1iQCa0XmDx2UzPgmZF">
        <Elements>
          <CardInfoForm
            {...props}
            plan={this.state.plan}
            onSubmit={this.createAccount}
          />
        </Elements>
      </StripeProvider>
    );
  };

  saveUserInfo = (firstName, lastName, email, password) => {
    this.setState({
      firstName: firstName,
      lastName: lastName,
      email: email,
      password: password,
      userInfoSaved: true
    });
  };

  saveChosenPlan = plan => {
    this.setState({ plan: plan });
  };

  createAccount = (stripeToken, coupon) => {
    const { firstName, lastName, email, password, plan } = this.state;
    if (plan.includes("hd")) {
      TagManager.dataLayer({
        dataLayer: {
            event: 'Subscribe',
            value: 'HD',
        }
      })
    } else {
      TagManager.dataLayer({
        dataLayer: {
            event: 'Subscribe',
            value: 'UHD',
        }
      })
    }
    // plan.includes("hd")
    //   ? window.gtag("event", "conversion", {
    //       send_to: "AW-809351643/LPXqCMW4hIUBENvz9oED",
    //       event_callback: () => {
    //         console.log("error with conversion");
    //       }
    //     })
    //   : window.gtag("event", "conversion", {
    //       send_to: "AW-809351643/XhicCNGOm4UBENvz9oED",
    //       event_callback: () => {
    //         console.log("error with conversion");
    //       }
    //     });

    const payload = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      password: password,
      payments: {
        platform: "stripe",
        stripeToken: stripeToken,
        plan: plan,
        coupon: coupon
      }
    };

    this.props.dispatch(Actions.signup(payload, this.props.history));
  };
}

export default withRouter(connect()(injectSheet(formStyle)(Signup)));



// WEBPACK FOOTER //
// ./src/js/Components/LandingPage/Signup.jsx